import React, {ReactNode} from 'react';
import classNames from 'classnames';

import './PageSurface.css';

export interface PageSurfaceProps {
    children: ReactNode;
    className?: string;
    noPadding?: boolean;
    isWhite?: boolean;
}

export const PageSurface: React.FC<PageSurfaceProps> = (
    {
        children,
        className,
        noPadding = false,
        isWhite = false,
    }
) => {
    return (
        <section
            className={classNames('PageSurface', className, {
                'PageSurface--no-padding': noPadding,
                'PageSurface--white': isWhite,
            })}
        >
            {children}
        </section>
    );
};

export default PageSurface;
